import React from 'react'

function ErrorPage() {
  return (
    <div>An error has occured. Please try again later.</div>
  )
}

export default ErrorPage